export const state = {};

export const getPage = (page_uuid) => ({
    page_uuid,
    title: '',
    host: '',
    path: '',
    full_page_url: '',
});
